import React from 'react';
import LinearThinkingNewsSlideItem from './LinearThinkingNewsSlideItem';
import { useKeenSlider } from 'keen-slider/react';
import styled from 'styled-components';
import ArrowButton from 'components/ArrowButton';
import { desktopFirstV3 } from 'style/breakpointsv3';

const SliderWrapper = styled.div`
  position: relative;
  padding: 0 50px;
  max-width: 100%;

  [class*='arrow-button'] {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .arrow-button-left {
    left: 0;
  }

  .arrow-button-right {
    right: 0;
  }
`;

const LinearThinkingNewsSlide = ({ data }) => {
  const [containerRef, slider] = useKeenSlider({
    slidesPerView: 3,
    spacing: 48,
    loop: true,
    duration: 2000,
    mode: 'free-snap',
    breakpoints: {
      [`(max-width: ${desktopFirstV3.md}px)`]: {
        slidesPerView: 2,
        spacing: 24
      },
      [`(max-width: ${desktopFirstV3.sm}px)`]: {
        slidesPerView: 1,
        spacing: 12
      }
    }
  });

  return (
    <SliderWrapper>
      <div ref={containerRef} className="keen-slider">
        {data.map((item, index) => (
          <LinearThinkingNewsSlideItem key={index} {...item} />
        ))}
      </div>
      {['left', 'right'].map(direction => (
        <ArrowButton
          key={direction}
          direction={direction}
          className={`arrow-button-${direction}`}
          onClick={() =>
            direction === 'left' ? slider?.prev() : slider?.next()
          }
        />
      ))}
    </SliderWrapper>
  );
};

export default LinearThinkingNewsSlide;
